import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncBulletinSetup({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/setupBulletin"));
  console.log("Loading", AsyncBulletinSetup.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncBulletinSetup;
